import { Reducer } from 'redux'

import {
  OverviewActionTypes,
  type OverviewAction,
  type OverviewState,
  initialState,
} from './types'

export * from './types'

export const reducer: Reducer<OverviewState, OverviewAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case OverviewActionTypes.SET_OVERVIEW: {
      return {
        ...state,
        overview: action.payload.overview,
      }
    }
    default:
      return state
  }
}
